module.exports = __webpack_public_path__ + "img/樊永刚.a26240e0.jpg";